import MuiTextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(MuiTextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.colors.grass,
      },
    },
    '&.Mui-error': {
      '& .MuiInputAdornment-root': {
        '& .MuiTypography-root': {
          color: theme.palette.error.main,
        },
      },
      '& .MuiInputBase-input': {
        color: theme.palette.error.main,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
      },
    },
    '&.Mui-disabled': {
      backgroundColor: theme.colors.paper,
      borderRadius: '0.5rem',

      '& .MuiTypography-root': {
        color: theme.colors.ash,
        opacity: 0.5,
      },

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.colors.dust,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '0.5rem',
      borderColor: theme.colors.ash,
    },
    '& input': {
      paddingTop: '1rem',
      paddingBottom: '1rem',

      '&[value=""]': {
        '& ~ fieldset': {
          borderColor: theme.colors.dust,
        },
      },
    },
    '& .MuiInputBase-input': {
      fontWeight: 900,

      '&::placeholder': {
        fontWeight: 400,
      },
    },
    '& .MuiTypography-root': {
      fontWeight: 900,
      color: theme.colors.ash,
    },
  },
}));

export const TextField: React.FC<any> = ({ variant = 'outlined', ...props }) => (
  <StyledTextField variant={variant} {...props} />
);
